// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-1bdd2391]{fill:var(--v-primary-base)}.cls-2[data-v-1bdd2391]{fill:#febf7c}.cls-3[data-v-1bdd2391]{fill:#fff3e7}", ""]);
// Exports
module.exports = exports;
